import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { useLocation } from "react-router-dom";
import MuiAlert from '@material-ui/lab/Alert';
import { } from "pages/redux/actions";
import Snackbar from '@material-ui/core/Snackbar';
import Avatar from '@material-ui/core/Avatar';
import axios from 'axios';
import moment from 'moment';
import logo from 'assets/img/defu.png';
import Badge from '@material-ui/core/Badge';

import { DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle, Navbar, Nav, Container, Media, Button,Modal,Row,Col,FormGroup,CardHeader,InputGroup,InputGroupAddon,InputGroupText,Input } from "reactstrap";
import { CircularProgress } from "@material-ui/core";

const AdminNavbar = (props) => {
  // const classes2 = useStyles2();
  // console.log(props.noti)
  // console.log(props.noti === undefined ? 'yes' : props.noti.length)
  // console.log(props.fullname)
  var atype = 'Student Account'
  if(props.adminValue===true){
    atype = 'Faculty Account'
  }
  if (props.superValue === true) {
    atype = 'Super Admin Account'
  }
  const [bgImage, setbgImage] = React.useState(logo);
  const location = useLocation();
  // const dispatch = useDispatch();
  const [sendingdata, setSendingdata] = React.useState('');
  const [namef, setNamef] = React.useState('');
  const [tt, settt] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [loading, setloading] = React.useState(false);
  const [right, setright] = React.useState(false);
  const [code, setcode] = React.useState(false);
  const [acode, setacode] = React.useState('');
  // const [open2, setOpen2] = React.useState(false);
  // let [nn, setnn] = React.useState(5);
  var nb = props.fullname.substring(0, 1)
  const fetchData = React.useCallback(() => {
    axios.get(process.env.REACT_APP_DOMAIN+"/profile", { 'headers': { 'Authorization': 'Token ' + props.token } })
      .then((response) => {
        if (response.data.photo != null) {
          var phurl = process.env.REACT_APP_DOMAIN+'' + response.data.photo;
          // console.log(phurl)
          setbgImage(phurl);
        }
        setNamef(nb)
      })
      .catch((error) => {
        setSendingdata('Something went wrong, Please Try Again')
        settt('error')
        setOpen(true);
        setNamef(nb)
      })
  }, [props.token,nb])
  React.useEffect(() => {
    fetchData()
    // console.log(nb)
    // console.log(props.token)
  }, [fetchData])

  const handleClose = (event, reason) => {
    setOpen(false);
  };

  const handleClosecode = (event, reason) => {
    setcode(false);
  };

  const handleSubmit = (event, reason) => {
    setloading(true)
    if (acode ==='KjsieitAdminTeachers@depact2021'){
      // console.log('right')
      axios.get(process.env.REACT_APP_DOMAIN + "/makesuper=" + props.username, { 'headers': { 'Authorization': 'Token ' + props.token } } )
      .then((response)=>{
        // console.log('yes')
        setSendingdata('You are a Super Admin now')
        settt('success')
        setOpen(true)
        setcode(false)
        setloading(false)
        props.fetch()
      })
        .catch((error) => {
          console.log(error)
          setSendingdata('Something went wrong')
          settt('error')
          setOpen(true)
          setloading(false)
      })
    }
    else{
      setSendingdata('Entered Code is Wrong')
      settt('error')
      setOpen(true)
      setloading(false)
    }
  };

  return (
    <>
      <Navbar className={"navbar-top bb-light-"+props.theme+" navbar-dark sbg-" + props.theme} expand="md" id="navbar-main" style={{ borderLeft: '2px solid #e8e9ee',position: '' }}>
        <Container fluid>
          <Link
            className={"h4 mb-0 textb-" + props.theme + " text-uppercase d-none d-lg-inline-block"}
            to={location.pathname}
          >
            {props.brandText}
          </Link>
          <Nav className={"align-items-center d-none d-md-flex ml-lg-auto"} navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm" style={{ backgroundColor: 'transparent' }}>
                    <Badge badgeContent={props.noti === undefined ? 0 : props.noti.length} color="primary">
                      <i className={"ni ni-bell-55 textb-" + props.theme}></i>
                    </Badge>
                  </span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className={"dropdown-menu-arrow pb-0 lg-width front bg-front cardbg-" + props.theme} right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className={"text-overflow m-0 texts-" + props.theme}>You have {props.noti === undefined ? 0 : props.noti.length} Notifications</h6>
                </DropdownItem>
                {(props.noti !== undefined ?
                  props.noti.map(function (noti, index) {
                    return (
                      <Button to={noti.link === null ? '#' : noti.link} tag={Link} onClick={() => { axios.get(process.env.REACT_APP_DOMAIN + "/markone="+noti.id, { 'headers': { 'Authorization': 'Token ' + props.token } });props.noti.splice(index,1)}} className={"text-left br-0 noti noti-"+noti.type} color='link' >
                        <div className="full-width"><p className={'m-0 text- noti-para texts-'+props.theme} >{noti.body}</p></div>
                        <div className="full-width text-right"><p className={'m-0 text- noti-para2 texts-'+props.theme} >{moment(noti.pdate).fromNow()}</p></div>
                      </Button>
                      // <DropdownItem className="noti-act" to={"user-profile"} tag={Link}>
                      //   <span className={"texts-" + props.theme+' noti-'+noti.type}>{noti.body}</span>
                      // </DropdownItem>
                      )
                  })
                :
                null
                )}
                {(props.noti === undefined ?
                  <DropdownItem tag="div" disabled >
                    <p className={'m-0 text- noti-para texts-'+props.theme} >No New Notifications U</p>
                  </DropdownItem>
                  :
                  (props.noti.length<1 ? 
                    <DropdownItem tag="div" disabled >
                      <p className={'m-0 text- noti-para texts-'+props.theme} >No New Notifications</p>
                    </DropdownItem>
                    :
                    null
                    )
                )}
                <DropdownItem className='m-0' divider />
                <Button onClick={() => { axios.get(process.env.REACT_APP_DOMAIN + "/markall", { 'headers': { 'Authorization': 'Token ' + props.token } }); props.clear() }} className={"text-left noti noti-"} color='link' >
                  <p className={'m-0 text- noti-para textsp-'+props.theme} >Mark all as read</p>
                </Button>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <Avatar alt="Remy Sharp" src={bgImage} className={"bgp-" + props.theme + " text-" + props.theme}>{namef}</Avatar>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className={"mb-0 text-sm font-weight-bold textb-" + props.theme}>
                      {props.fullname}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className={"dropdown-menu-arrow cardbg-" + props.theme} right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className={"text-overflow m-0 texts-" + props.theme}>{atype}</h6>
                </DropdownItem>
                <DropdownItem to={"/main/user-profile"} tag={Link}>
                  <i className={"ni ni-single-02 texts-"+props.theme} />
                  <span className={"texts-"+props.theme}>My profile</span>
                </DropdownItem>
                {(props.superValue ?
                  null
                  :
                  <DropdownItem onClick={()=> setcode(true)} >
                    <i className={"ni ni-circle-08 texts-" + props.theme} />
                    <span className={"texts-" + props.theme}>SuperAdmin</span>
                  </DropdownItem>
                )}
                {(props.adminValue ? 
                  <DropdownItem to={"/main/published-events"} tag={Link}>
                    <i className={"ni ni-book-bookmark  texts-" + props.theme} />
                    <span className={"texts-" + props.theme}>Published Events</span>
                  </DropdownItem>
                :
                  <DropdownItem to={"/main/registered-events"} tag={Link}>
                    <i className={"ni ni-book-bookmark  texts-" + props.theme} />
                    <span className={"texts-" + props.theme}>Registered Events</span>
                  </DropdownItem>
                )}
                
                <DropdownItem to="/main/settings" tag={Link}>
                  <i className={"ni ni-settings-gear-65 texts-"+props.theme} />
                  <span className={"texts-"+props.theme}>Settings</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="/auth/logout">
                  <i className={"ni ni-button-power texts-"+props.theme} />
                  <span className={"texts-"+props.theme}>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
              <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
            </Snackbar>
          </Nav>
          <Modal
            className="modal-dialog-centered"
            isOpen={code}
            toggle={handleClosecode}>
              
            <Row className="modal-body bg-orangec pt-0 pb-0 mb-2">
              <CardHeader className={"cardbg-" + props.theme + " cardb-" + props.theme}>
                <h1 className={"textb-" + props.theme}>Convert to Super Admin Account</h1>
              </CardHeader>
            </Row>
            <Row className="p-3">
              <Col lg="12" xl="12" sm="12" md="12" className="">
                <FormGroup>
                  <InputGroup className="input-group-alternative" style={{ backgroundColor: 'white' }}>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input placeholder="Enter Super Admin Code" type="password" value={acode} onChange={(e) => { setacode(e.target.value); e.target.value === 'KjsieitAdminTeachers@depact2021' ? setright(true) : setright(false) }} style={{ marginTop: '2px' }} />
                    <InputGroupAddon addonType="append" style={{ backgroundColor: 'white' }}>
                      <InputGroupText>
                        {right ? <i className="ni ni-check-bold text-green"></i> : null}
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row className="p-3">
              <Col lg="6" xl="6" sm="6" md="6" className="mt-2 text-left ">
                <Button color="danger" disabled={loading} onClick={handleClosecode} >Close</Button>
              </Col>
              <Col lg="6" xl="6" sm="6" md="6" className="mt-2 text-right ">
                <Button color="info" outline disabled={loading} onClick={handleSubmit} >{(loading ? <CircularProgress size="20px" style={{color: 'white'}} />:'Go')}</Button>
              </Col>
            </Row>
          </Modal>
        </Container>
      </Navbar>
    </>
  );
};

export const mapStateToProps = state => {
  // console.log("this is the state", state);
  return {
    superValue: state.switchRoutes.superadmin,
    adminValue: state.switchRoutes.admin,
    userValue: state.switchRoutes.user,
    username: state.userName,
    fullname: state.tempUser,
    theme: state.theme,
    text: state.text,
    token: state.token,
  }
}

export default connect(mapStateToProps)(AdminNavbar);









